<div class="modal-header">
  <h4 class="modal-title cs-modal-title">MUTING YOURSELF</h4>
  <button type="button" class="close" aria-label="Close" (click)="dialog.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div [innerHTML]="message"></div>
</div>

<div class="modal-footer d-flex ng-scope">
  <button class="btn btn-secondary" type="button" (click)="dialog.dismiss('Cross click')">No</button>
  <button type="submit" class="btn btn-primary ml-auto" (click)="onSubmit()">Yes</button>
</div>
